import { mutateGraphQL } from '~/hooks/graphql.js';

const LogoutMutation = `
    mutation Logout {
        logout(input: {}) {
            status
        }
    }
`;

export const getLogoutMutationHandler = () => {
    const { mutationHandler } = mutateGraphQL(LogoutMutation);

    return { mutationHandler };
}